import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";
import NavegacionFarms from "../../components/NavigableComponents/NavigableFarms";
import CustomButtonsRedirectSilos from "../../components/ButtonComponentsPanel/CustomButtonsRedirectSilos";
import SilosNavesComponents from "../../components/SilosComponents/SilosNavesComponents";
export default function NavesSilos() {

    const { t } = useTranslation();

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="col-12 col-lg-11 mx-auto">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/Farms/'}>{t("Global_Label_Text_Farms")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/Silos/'}>{t("Global_Label_Text_Silos")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/NavesSilos/'}>{t("Global_Label_Text_Ships")}</Link></li>
                                </ol>
                            </nav>
                            <NavegacionFarms />
                        </div>
                    </div>
                </div>
                <CustomButtonsRedirectSilos />
                <div>
                    <SilosNavesComponents />
                </div>

                <br />
            </div > : ""}
        </div>
    );

}
